const prod = {
  url: {
    API_URL: "https://mrakovic-api.qatrace.com/api/",
    STORAGE_URL: "https://mrakovic-api.qatrace.com/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    ETHERNET_PRINTER_1_URL: "http://192.168.2.184:9100",
    ETHERNET_PRINTER_2_URL: "http://192.168.2.185:9100",
    NAME: "MRAKOVIC - QA Trace",
  },
};

const stg = {
  url: {
    API_URL: "https://mrakovic-api.qatrace.com/api/",
    STORAGE_URL: "https://mrakovic-api.qatrace.com/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    ETHERNET_PRINTER_1_URL: "http://192.168.2.184:9100",
    ETHERNET_PRINTER_2_URL: "http://192.168.2.185:9100",
    NAME: "MRAKOVIC - QA Trace",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:8001/api/",
    STORAGE_URL: "http://localhost:8001/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    ETHERNET_PRINTER_1_URL: "http://192.168.2.184:9100",
    ETHERNET_PRINTER_2_URL: "http://192.168.2.185:9100",
    NAME: "MRAKOVIC - QA Trace",
  },
};

// Determine which config to use based on environment
let selectedConfig;
if (process.env.NODE_ENV === "development") {
  selectedConfig = dev;
} else {
  // In production builds, check REACT_APP_ENV to choose between prod and stg
  const buildEnv = process.env.REACT_APP_ENV;
  selectedConfig = buildEnv === "stg" ? stg : prod;
}

export const config = selectedConfig;
